<div class="row">
  <div class="col-sm-12">
    <form id="observacoesDocVinculoForm" autocomplete="off" [formGroup]="observacoesDocForm" (ngSubmit)="salvar()">
      <div class="row row-cols-1 g-3">
        <div class="col form-group">
          <label for="tipoDocumentoId" class="form-label">Tipo Documento</label>
          <nz-select formControlName="tipoDocumentoId" nzShowSearch nzAllowClear nzPlaceHolder="Tipo Documento"
            nzSize="large" [compareWith]="compareFn">
            <nz-option [nzValue]="item.id" [nzLabel]="item.nomeTipoDocumento" *ngFor="let item of tipoDocumentoList" />
          </nz-select>
        </div>

        <div class="col form-group">
          <label for="arquivos" class="form-label">Enviar Arquivos</label>
          <ng-container *ngIf="arquivos.length == 0">
            <app-upload-arquivo [limite]="10" nz-tooltip [tiposArquivos]="isFileTypeAccepted"
              nzTooltipTitle="Arquivo" (arquivosEmit)="arquivosEmit($event)"></app-upload-arquivo>
          </ng-container>
          <ng-container *ngIf="arquivos.length > 0">
            <div class="col-12 rounded-3 border p-3">
              <div class="row">
                <div class="col-8 d-flex align-items-center">
                  {{ arquivoRecebido?.nome }}
                </div>
                <div class="col-4 d-flex align-items-center justify-content-end">
                  <button nz-button nzType="primary" nz-popover
                  nzPopoverContent="Delete" nzPopoverPlacement="top" type="button" (click)="removerArquivo()">
                    <span nz-icon nzType="delete" nzTheme="outline"></span>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

      </div>
    </form>
  </div>
  <div class="row mt-4">
    <div class="col-12 d-flex justify-content-end">
      <button nz-button nzType="default" class="me-3" (click)="reset()">Cancelar</button>
    <button nz-button nzType="primary" type="submit" form="observacoesDocVinculoForm" [disabled]="!observacoesDocForm.valid" >Adicionar</button>
    </div>
  </div>
</div>
